import { interopTestSuffix } from 'config/urlHelper';

export const stagingConfig = {
  API: {
    ROOT_URL: () => 'https://api.staging.econsult.awshealth.net',
    IE_ROOT_URL: practiceId => `https://${practiceId}${interopTestSuffix()}.staging.econsulttest.health/cors-es`,
    SUBMISSION_URL: practiceId => `https://${practiceId}${interopTestSuffix()}.staging.econsult.awshealth.net/api/consultation/submitsession`,
    POSTCODE_URL: (practiceId, postcode) => `https://${practiceId}${interopTestSuffix()}.staging.econsulttest.health/findMatchingPostcodes/${postcode}`,
    ADDRESSES_URL: (practiceId, postcode) => `https://${practiceId}${interopTestSuffix()}.staging.econsulttest.health/searchPostcode/${postcode}`,
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/staging.frontend.econsult.health/econsult-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
};
